<template>
  <div class="need-help">
    <div class="content">
      <div class="text-bold">Need some help?</div>
      <div>Trained security professionals are here to help.</div>
      <div>
        Live Chat
        <span>
          <PhoneLink location="Module - Need Help"/>
        </span>
      </div>
    </div>
    <div>
      <img src="/img/SupportCollage.png" alt="Support" />
    </div>
  </div>
</template>

<script>
import PhoneLink from "./PhoneLink.vue";
export default {
  components: {
    PhoneLink
  }
};
</script>

<style lang="scss" scoped>
.need-help {
  display: flex;
  max-width: 312px;
  width: 100%;
  justify-content: space-between;
}

.content {
  max-width: 213px;
}
</style>
